<script>
  import { onMount } from "svelte"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../Script/queryString"
  import { deleteRequest, getRequest, patchRequest } from "../../../Script/apiMethods"
  import ApplicationState from "../../../Stores/applicationStates"
  import Navbar from "../../../Shared/Navbar/index.svelte"
  import Footer from "../../../Shared/footer.svelte"
  import notify from "../../../Script/notify"
  import Table from "../../../Shared/Table/table.svelte"
  import List from "./Components/list.svelte"
  import FilterComponent from "./Components/filterComponent.svelte"
  import LoadingScreen from "../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import SinglePublish from "../../Publish/SinglePublish/Stores/singlePublishStore"

  // import { fetchBadgeList } from "../../Publish/Badge/Script/api"
  let query = queryStringToJSON($querystring)

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let showLoader = true

  /**
   * @type {Number} - how many list need to show
   */
  let limit

  /**
   * @type {Number} - which page list need to show
   */
  let page

  /**
   * @type {Number} - which order need to show (in order to date)
   */
  let sort

  /**
   * @type {Number} -which sory type need to show (date or name)
   */
  let sortBy

  /**
   * @typedef {Object} search - it contains what user want to search (searchvalue) in which parameter (searchParam)
   * @type {Object}
   * it contains what user want to search (searchvalue) in which parameter (searchParam)
   *
   * @property {String} searchvalue - what value need to search.
   * @property {String} searchParam - on which param need to show
   */
  let search = {
    searchParam: "name",
    searchvalue: "",
  }

  /**
   * @type {String} - from date of filter list
   */
  let startDate = null

  /**
   * @type {String} - to date of filter list
   */
  let endDate = null

  /**
   * @type {String} - which state document need to show
   */
  let status = null

  /**
   * @type {Object} - response for fetch document api call
   */
  let DocumentList = {
    dockets: [],
  }

  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  let closeNotification = {
    close() {},
  }

  let loaderMsg = "Fetching Docket list"

  const infoDetails = {
    PENDING: "bg-yellow-500",
    APPROVED: "bg-blue-500",
    SIGNED: "bg-lime-500",
    COMPLETED: "bg-green-500",
    REJECTED: "bg-red-500",
  }

  onMount(async () => {
    try {
      // Prevent execution if unauthorized (because pop() is asynchronous)
      if (!$ApplicationState.pdfEnabled || !$ApplicationState.msignToken) return

      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      startDate = query.sdate ? query.sdate : ""
      endDate = query.edate ? query.edate : ""
      status = query.status ? query.status : ""
      search.searchParam = query.sin ? query.sin : "name"
      search.searchvalue = query.sname ? query.sname : ""
      await fetchList()
    } catch (error) {
      console.error(error)
      const info = "PAGE: List of Docket\nEVENT: onMount"
      notify.danger(error, info)
    }
  })

  /**
   * @description function for fetch publsih process documents.
   */
  const fetchList = async () => {
    try {
      showLoader = true

      const REQ_URL = `/api/pdf-signing/v2/docket?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${status ? `&status=${status}` : ``}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`
      const CONFIG = {
        // ${status ? `&state=${status}` : ``}
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      }

      const data = await getRequest(REQ_URL, CONFIG)

      DocumentList = data
      push(`/signing/dockets?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${status ? `&status=${status}` : ``}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`)
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      showLoader = false
    }
  }

  /**
   * @description Function to fetch templates based on user input.
   */
  const whileChangingEntries = async (e) => {
    try {
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      // if (e.detail.filter.date.status) {
      status = e.detail.filter.date.status
      startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
      endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      // } else {
      //   status = ""
      // }
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await fetchList()
    } catch (error) {
      const info = "PAGE: List of Docket\nEVENT: Error occurred during actions such as sorting by date, changing display entries, changing date filter, searching by name/ id/ status, or navigating pages."
      notify.danger(error, info)
    }
  }

  /**
   * @description Function to reset the user inputs
   */
  const resetList = async () => {
    try {
      limit = 10
      page = 1
      sort = -1
      sortBy = "date"
      search.searchvalue = ""
      search.searchParam = "name"
      startDate = ""
      endDate = ""
      status = ""
      await fetchList()
    } catch (error) {
      const info = "PAGE: List of Docket\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    }
  }

  const handleResumePublish = async (e) => {
    try {
      showLoader = true
      loaderMsg = "Fetching Docket Details"

      const { documentID, docketID } = e.detail

      const documentData = await fetchDocumentDetails(documentID)

      if (!documentData.fileHash) {
        await uploadFile(documentID, docketID)
      } else {
        $SinglePublish = {}
        $SinglePublish.documentId = documentID
        $SinglePublish.docketId = docketID
        $SinglePublish.fileHash = documentData.fileHash

        if (documentData.dataHash) {
          if (documentData.txidPublished) {
            await patchRequest(
              `/api/pdf-signing/v2/docket/${docketID}`,
              {},
              {
                headers: {
                  "msign-org-token": $ApplicationState.msignToken,
                },
              }
            )

            push(`#/signing/single/docket?id=${docketID}`)
          } else {
            $SinglePublish.dataHash = documentData.dataHash
            $SinglePublish.options = JSON.parse(documentData.options)
            $SinglePublish.Json = JSON.parse(documentData.metadata)
            push(`/publish/single/preview?documentId=${documentID}`)
          }
        } else {
          push(`/publish/single/choose_template?documentId=${documentID}`)
        }
      }
    } catch (error) {
      console.error(error)
      if (error == "P2BCODE::DOCUMENT_DOES_NOT_EXIST") error = "P2BCODE::DOCKET_LINKED_DOC_DOES_NOT_EXIST"
      closeNotification.close()
      const info = "PAGE: List of Docket\nEVENT: While resuming docket publish"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
      loaderMsg = "Fetching Docket list"
    }
  }

  const uploadFile = async (documentID, docketID) => {
    try {
      // Fetch File
      const fileData = await getRequest(`/api/pdf-signing/v2/docket/${docketID}/file`, {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
        responseType: "blob",
      })

      // Create a new File object with the Blob and provide a default filename and type
      let file = new File([fileData], query.id, {
        type: "application/pdf",
      })

      const data = await patchRequest(
        `/api/swagger/v2/documents/${documentID}/add-file`,
        {
          documentID: documentID,
          file: file,
          docketID: docketID,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": $ApplicationState.token,
          },
        }
      )

      $SinglePublish = {}
      $SinglePublish.documentId = documentID
      $SinglePublish.docketId = docketID
      $SinglePublish.fileHash = data.fileHash

      push(`/publish/single/choose_template?documentId=${documentID}`)
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  const fetchDocumentDetails = async (id) => {
    try {
      const { document } = await getRequest(`/api/swagger/v2/documents/${id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      return document
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  const handleReleaseDocket = async (e) => {
    try {
      showLoader = true

      const { docketID, documentID } = e.detail

      loaderMsg = "Releasing Docket"
      // Release Docket
      await deleteRequest(`/api/pdf-signing/v2/docket/${docketID}`, {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      })

      if (documentID) {
        loaderMsg = "Releasing Document"
        // Release Document
        await deleteRequest(`/api/swagger/v2/documents/${documentID}/release?force=true`, {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })
      }

      loaderMsg = "Fetching Docket list"
      await fetchList()
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: List of Docket\nEVENT: While releasing docket"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
    }
  }
</script>

<svelte:head>
  <title>Dockets</title>
</svelte:head>

{#if showLoader}
  <LoadingScreen msg={loaderMsg} />
{/if}
<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6 pb-40 pt-3">
    <div class="relative mx-auto mt-8 h-full w-full max-w-[920px] rounded-md bg-[#f7f7f7] dark:bg-bodyblack">
      <Table {infoDetails} on:changeEntries={whileChangingEntries} on:resetEntries={resetList} title="List of Docket" filterComponent={FilterComponent} count={DocumentList.count} jsonData={DocumentList.dockets || []} filter={true}>
        {#each DocumentList.dockets || [] as json}
          <List on:confirm={handleResumePublish} on:release={handleReleaseDocket} {json} />
        {:else}
          <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-xl dark:bg-darkgray dark:text-white sm:text-2xl">There is no Docket</div>
        {/each}
      </Table>
    </div>
  </div>

  <Footer />
</div>
